<template>
  <div class="sort-order">
    <h3 v-text="translate('lblSortOrder')"></h3>
    <select @change="sortResults" v-model="order" name="sort">
      <option v-if="!mandatory" value="" v-text="translate('lblSortOrderUnsorted')"></option>
      <option v-for="option in sortOptions" :key="option.id" :value="option.id" v-text="option.name"></option>
    </select>
  </div>
</template>

<script>
import { load } from '../../shared/State';

export default {
  name: 'SortOrder',
  data: () => ({
    order: '',
    restoredOrder: null,
  }),
  props: {
    sortOptions: {
      type: Array,
      required: true,
    },
    presetOrder: String,
    filterSettingsKey: String,
    mandatory: Boolean,
  },
  watch: {
    presetOrder(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.order = newValue || '';
      }
    },
  },
  methods: {
    sortResults() {
      this.$emit('change', this.order);
    },
    loadUrlParameters() {
      const filterSettings = load(this.filterSettingsKey);
      if (filterSettings) {
        this.restoredOrder = filterSettings.sortId;
      }
    },
  },
  created() {
    this.loadUrlParameters();
    this.order = this.restoredOrder || this.presetOrder || '';
  },
};
</script>

<style lang="scss">
.sort-order select {
  background-color: $color-kws-black-5;

  .bg-white & {
    background-color: $color-white;
  }
}
</style>

<style lang="scss" scoped>
.sort-order {
  padding: rem(12px) 0;
  margin-bottom: rem(16px);

  h3 {
    margin-bottom: 0;
  }
}
</style>
